package team.platforma.materialextension.sample_screens

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.ArrowForward
import androidx.compose.material3.Button
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.unit.dp
import team.platforma.multiplatform_material_extension.ui.buttons.ExtraTextButton
import team.platforma.multiplatform_material_extension.ui.buttons.utils.ButtonIcon
import team.platforma.multiplatform_material_extension.ui.buttons.utils.ButtonText
import team.platforma.multiplatform_material_extension.ui.flexbox.FlexGravity
import team.platforma.multiplatform_material_extension.ui.flexbox.InputChipFlexBox
import team.platforma.multiplatform_material_extension.ui.flexbox.InputChipItem
import team.platforma.multiplatform_material_extension.util.forms.FormProperties
import team.platforma.multiplatform_material_extension.util.forms.isValid
import team.platforma.multiplatform_material_extension.util.forms.rememberForms

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun WebView() {
//    val webViewForWeb = remember { JsFullScreenIframe(
//        rootId = "root",
//        iframeId = "webView",
//        canvasId = "webViewCanvas"
//    ) }
//
//    webViewForWeb.show(
//        url = "https://api.foiv.dev.x840.ru/rules/",
//        topBar = {
//            TopAppBar(
//                modifier = Modifier.alpha(1f),
//                title = {
//                    Text(
//                        text = "Соглашение"
//                    )
//                },
//                navigationIcon = {
//                    IconButton(
//                        onClick = {
//                            webViewForWeb.hide()
//                        }
//                    ) {
//                        Icon(
//                            painter = painterResource(Res.drawable.right_arrow),
//                            contentDescription = null
//                        )
//                    }
//                }
//            )
//        }
//    )
    var showAll by remember { mutableStateOf(false) }
    val interests = listOf<InputChipItem>(
        InputChipItem(0, "Спорт", false),
        InputChipItem(1, "Активный отдых", false),
        InputChipItem(2, "Экология", true),
        InputChipItem(3, "Природная охрана", true),
        InputChipItem(4, "ЖКХ",true),
        InputChipItem(5, "Поездки",false),
        InputChipItem(6,"Туризм",false),
        InputChipItem(7,"Право",false),
        InputChipItem(8,"Активный отдых в России",false),
        InputChipItem(9,"Хорошие новости",false),
        InputChipItem(10,"Море",false),

    )
    var displayedInterests by remember { mutableStateOf(listOf<InputChipItem>()) }
    LaunchedEffect(Unit){
        snapshotFlow { showAll }.collect {
            val filteredInterests = interests.filter { it.enabled }
            displayedInterests = if (showAll) {
                filteredInterests.map { InputChipItem(it.id, it.title, it.enabled) }
            } else {
                filteredInterests.take(1).map { InputChipItem(it.id, it.title, it.enabled) }
            }
        }
    }
    Box(
        modifier = Modifier.fillMaxSize()
    ) {

        val form by rememberForms()

        var chipList by remember { mutableStateOf(interests) }


        LazyColumn() {
            item {
                InputChipFlexBox(
                    displayedInterests,
                    onChipClick = { item ->

                    },
                    formProperties = FormProperties(
                        form = form,
                        key = "interests"
                    ),
                    flexGravity = FlexGravity.START,
                    isChipClickable = false
                )
            }
        }

        ExtraTextButton(
            modifier = Modifier.align(Alignment.BottomStart),
            onClick = { showAll = !showAll },
            buttonText = ButtonText(text = if (showAll) "Свернуть" else "Показать все"),
            buttonIcon = ButtonIcon(
                painter = if (showAll) rememberVectorPainter(Icons.AutoMirrored.Filled.ArrowBack) else rememberVectorPainter(
                    Icons.AutoMirrored.Filled.ArrowForward
                ),
                size = 24.dp,
                attachText = true
            )
        )
        Button(
            modifier = Modifier.align(Alignment.BottomEnd),
            enabled = form.isValid(),
            onClick = {

            }
        ) {
            Text("Valid")
        }

    }

}